module.exports = __webpack_public_path__ + "static/media/06-Stuttgart@2x.fd0ed404.jpg";